import script from "./rec-causes-selector.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-causes-selector.vue?vue&type=script&lang=ts&setup=true"

import "./rec-causes-selector.vue?vue&type=style&index=0&id=f89fbdc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f89fbdc0"]])

export default __exports__